var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ledBox",class:_vm.isOn ? 'blink' : 'noblink'},[_c('img',{attrs:{"width":"100%","height":"auto","src":require("@/assets/ledDrum.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }